var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 5C3.5 4.44772 3.94772 4 4.5 4H19.5C20.0523 4 20.5 4.44772 20.5 5V22C20.5 22.5523 20.0523 23 19.5 23H4.5C3.94772 23 3.5 22.5523 3.5 22V5ZM5.5 6V21H18.5V6H5.5Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9C10.5523 9 11 9.44772 11 10V16.5C11 17.0523 10.5523 17.5 10 17.5C9.44772 17.5 9 17.0523 9 16.5V10C9 9.44772 9.44772 9 10 9Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 9C14.5523 9 15 9.44772 15 10V16.5C15 17.0523 14.5523 17.5 14 17.5C13.4477 17.5 13 17.0523 13 16.5V10C13 9.44772 13.4477 9 14 9Z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5C1 4.44772 1.44772 4 2 4H22C22.5523 4 23 4.44772 23 5C23 5.55228 22.5523 6 22 6H2C1.44772 6 1 5.55228 1 5Z",
    fill: "#1C1C1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76761 1.51932C8.94315 1.19908 9.2793 1 9.6445 1H14.3885C14.7568 1 15.0952 1.20239 15.2695 1.5268L16.881 4.5268C17.0474 4.83671 17.0388 5.2113 16.8583 5.51322C16.6777 5.81515 16.3518 6 16 6H8C7.64669 6 7.3196 5.81356 7.13957 5.50957C6.95953 5.20557 6.95328 4.82913 7.12311 4.51932L8.76761 1.51932ZM10.2367 3L9.68856 4H14.3277L13.7906 3H10.2367Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.77f2632d770065ecc171e1921edcb5e8.svg";
export { ForwardRef as ReactComponent };